import React from "react";
// import flexible from '../../utils/flexible';
import "./index.less";

class PrivacyAgreement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
        window.location.replace(
            "https://www.hellogil.com/h5Static/PrivacyAgreement2GuanChe.html"
        );
    }

    render() {
        // document.title = '服务协议';
        return (
            <div className="page_type_h5_select">
                <article id="PrivacyAgreement2">
                    <h2 style={{ textAlign: "center" }}>慧管车APP隐私政策</h2>

                    <section className="dataTime">
                        <p>本版本发布日期：2024年03月28日</p>
                        <p>本版本生效日期：2024年04月04日</p>
                    </section>
                    <section>
                        <h3>引言</h3>
                    </section>
                    <section>
                        浙江绿色慧联有限公司（以下简称“我们”或“绿色慧联”）非常重视用户的隐私和个人信息保护，并根据相关法律法规及国家标准，制定《慧管车APP隐私政策》（以下简称“本政策”），提醒您仔细阅读并了解。本政策阐述了我们如何收集和处理您的个人信息，并为您提供访问和控制您的个人信息的途径。在为您提供优质的产品和服务的同时，我们将根据本政策收集、使用、共享、存储和保护您的个人信息。
                    </section>
                    <section>
                        本政策适用于我们通过慧管车APP为您提供的所有服务。但本政策不适用于：
                    </section>
                    <section>
                        <ul>
                            <li>任何第三方向您提供的产品及服务；</li>
                            <li>
                                具有单独的隐私政策并且这些政策并未纳入本政策的特定产品及服务。
                            </li>
                        </ul>
                    </section>
                    <section>
                        我们收集和处理个人信息会因具体产品/服务场景而有所不同，请以您使用产品/服务的具体场景为准。
                    </section>
                    <section>
                        <p>
                            我们深知个人信息对您的重要性，秉承您对绿色慧联产品的高度期待值而严谨对待您的个人信息。客户个人信息的保密性和完整性是我们的重点关注领域。我们努力创造和维护与您的互信关系，为保护您的个人信息恪守以下原则：权责一致、目的明确、选择同意、最少必要、确保安全、主体参与、公开透明。同时，我们承诺按业界成熟的安全标准，采取相应的安全保护措施以充分保护您的个人信息。
                        </p>
                        <p>
                            如果您有任何疑问、意见或建议，请通过以下方式与我们联系：400-826-2266
                        </p>
                        <p>
                            本隐私政策将帮助您了解以下内容，您可以根据以下索引阅读相应章节，进一步了解本政策的具体约定：
                        </p>
                        <p>一、我们如何收集和使用您的个人信息</p>
                        <p>二、我们如何共享、转让、公开披露您的个人数据</p>
                        <p>三、我们如何保护和保存您的个人信息</p>
                        <p>四、您如何管理您的个人信息</p>
                        <p>五、儿童个人信息的处理</p>
                        <p>六、通知和修订</p>
                        <p>七、如何联系我们</p>
                    </section>
                    <section>
                        <h3>一、我们如何收集和使用您的个人信息</h3>
                        <p>
                            为本政策之目的，“个人信息”，是指以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息，不包括匿名化处理后的信息。
                            <b>
                                “敏感个人信息”是指一旦泄露或者非法使用，容易导致自然人的人格尊严受到侵害或者人身、财产安全受到危害的个人信息，包括生物识别、宗教信仰、特定身份、医疗健康、金融账户、行踪轨迹信息以及不满十四周岁未成年人的个人信息。
                            </b>
                            相比其他个人信息，敏感个人信息可能对您的个人权益影响更大。我们在此善意的提醒您需在谨慎考虑后再向我们提供您的敏感个人信息。
                        </p>
                        <p>
                            我们会遵循正当、合法、必要的原则，在下述场景中收集和使用您的个人信息：
                        </p>
                        <h4>1.1用户注册、登录</h4>
                        <p>
                            1）注册：当您进行新用户注册时，您首先需要向慧管车提交申请并经由慧管车审核后为您创建账号；
                        </p>
                        <p>
                            2）登录：您可以通过该账户登录慧管车APP，为帮助您完成慧管车APP的登录，我们将收集您的账户信息（企业标识、手机号、验证码、账户名、密码）
                        </p>
                        <h4>1.2 保障运营与安全运行</h4>
                        <p>
                            为维护服务正常运行，保障账户和交易安全，在您访问及使用我们的产品/服务过程中，我们需要收集您的日志信息、设备信息，包括您的硬件设备型号、屏幕宽度和高度、您所使用的软件版本信息、您的操作系统及版本、您的IP地址、移动网络信息、您的设备ID、设备制造商、设备型号、运营商、运行中进程、Android
                            ID、IDFA、IDFV、OAID、UUID，用于判断账户安全、检测及防范安全事件，以便为您提供安全、可信的产品与使用环境。
                        </p>
                        <h4>1.3 客服、其他用户响应功能</h4>
                        <p>
                            当您与我们的客服（在线客服、客服热线等）互动时或使用其他用户响应功能时（包括：服务咨询、提出我们的产品与服务的售后申请、行使您的相关个人信息控制权、其他客户投诉和需求），为了您的账号与系统安全，我们可能需要您先行提供账号信息，并与您之前的个人信息相匹配以验证您的用户身份。在您使用客服或其他用户响应功能时，我们可能还会需要收集您的如下个人信息：
                            <b>
                                联系方式（您与我们联系时使用的电话号码/电子邮箱或您向我们主动提供的其他联系方式）、您与我们的沟通信息（包括文件/文字/图片/音视频/通话记录形式）
                            </b>
                            。当您需要我们提供与您订单相关的客服服务时，我们可能会查询您此账号下的订单信息，并同步给相关服务提供方，以便给予您适当的帮助和处理，当您在与我们的客服人员沟通时，基于您的不同客服需求，可能需您提供上述信息以外的其他信息，以便我们为您解决问题，具体以实际场景为准。我们收集这些信息是为了调查事实与帮助您解决问题，如您拒绝提供可能导致您无法使用我们的客服响应机制。
                        </p>
                        <h4>1.4数据统计分析</h4>
                        <p>
                            请您知晓，我们可能会对您提供的上述信息采取匿名化或去标识化，形成不包含您个人身份识别信息的统计型信息和报告，为研究开发、用户群体分析、产品/服务改良目的进行妥善处理，可能会包括对外提供或公开。
                        </p>
                        <h4>1.5运营商在使用本APP开展业务时的说明</h4>
                        <p>
                            当您作为运营商管理员角色使用我们APP开展业务（包括：管理车辆、管理客户、管理订单、管理财务等）时，请确保在录入他人个人信息或者查看他人个人信息前，应确保仅限于实现业务运营及管理目的所必需的最小字段，已充分告知个人信息主体相关数据收集的目的、范围和方式并获得个人信息主体的授权同意，
                            <b>
                                请遵守适用法律法规要求，避免侵犯他人的个人信息权益或违反相关法律法规规定。
                            </b>
                        </p>
                        <h4>1.6慧管车权限获取说明 </h4>
                        <p>
                            为向您提供便捷、优质的服务，我们的产品和/或服务中可能需要使用系统权限，这些权限只有经过您的明示授权才会开启，并且仅在相关功能或服务需要时才会收集您的个人信息。我们对慧管车APP所调用的系统权限进行归纳整理，您可以根据实际需要对相关权限进行管理，具体权限调用内容详见下文应用权限说明。
                        </p>
                        <p>
                            您可以在您的移动终端中逐项查看您上述权限的开启状态，并可以决定将这些权限随时开启或关闭。
                            <b>
                                请您注意，您开启这些权限即代表您授权我们可以收集和使用这些个人信息来实现上述的功能，您关闭权限即代表您取消了这些授权，则我们将不再继续收集和使用您的这些个人信息，也无法为您提供上述与这些授权所对应的功能。您关闭权限的决定不会影响此前基于您的授权所进行的个人信息的处理。
                            </b>
                        </p>
                    </section>
                    <section>
                        <h4>1、iOS系统调用权限说明</h4>
                        <div className="scorll-view">
                            <div className="table1">
                                <div className="table-view">
                                    <div className="table-clumn">
                                        <b>设备权限</b>
                                    </div>
                                    <div className="table-clumn">
                                        <b>调用权限的目的</b>
                                    </div>
                                    <div className="table-clumn">
                                        <b>是否询问</b>
                                    </div>
                                    <div className="table-clumn">
                                        <b>用户可否关闭权限</b>
                                    </div>
                                </div>

                                <div className="table-view">
                                    <div className="table-clumn">相册</div>
                                    <div className="table-clumn">
                                        帮助您完成新建维修、新建出险、新建年审、新建换车、新建交车、新建收车、新建车况物资检查、交收车编辑异常明细、新建线索跟进、新建调账功能
                                    </div>
                                    <div className="table-clumn">是</div>
                                    <div className="table-clumn">是</div>
                                </div>
                                <div className="table-view">
                                    <div className="table-clumn">相机</div>
                                    <div className="table-clumn">
                                        帮助您完成新建维修、新建出险、新建年审、新建换车、新建交车、新建收车、新建车况物资检查、交收车编辑异常明细、新建线索跟进、新建调账、新增设备二维码扫描功能
                                    </div>
                                    <div className="table-clumn">是</div>
                                    <div className="table-clumn">是</div>
                                </div>
                                <div className="table-view">
                                    <div className="table-clumn">位置</div>
                                    <div className="table-clumn">
                                        帮助您完成围栏预警位置查看、车辆查看及管理
                                    </div>
                                    <div className="table-clumn">是</div>
                                    <div className="table-clumn">是</div>
                                </div>
                            </div>
                        </div>
                        <h4>2、Android系统调用权限说明</h4>
                        <div className="scorll-view">
                            <div className="table1">
                                <div className="table-view">
                                    <div className="table-clumn">
                                        <b>设备权限</b>
                                    </div>
                                    <div className="table-clumn">
                                        <b>调用权限的目的</b>
                                    </div>
                                    <div className="table-clumn">
                                        <b>是否询问</b>
                                    </div>
                                    <div className="table-clumn">
                                        <b>用户可否关闭权限</b>
                                    </div>
                                </div>

                                <div className="table-view">
                                    <div className="table-clumn">
                                        读取及写入存储器
                                    </div>
                                    <div className="table-clumn">
                                        存储和使用本产品相关目录下产品服务时需要的文档和数据资料，保障产品的正常运行；APP更新升级、文件存储。
                                    </div>
                                    <div className="table-clumn">是</div>
                                    <div className="table-clumn">是</div>
                                </div>
                                <div className="table-view">
                                    <div className="table-clumn">相机</div>
                                    <div className="table-clumn">
                                        帮助您完成新建维修、新建出险、新建年审、新建换车、新建交车、新建收车、新建车况物资检查、交收车编辑异常明细、新建线索跟进、新建调账、新增设备拍照、扫描功能
                                    </div>
                                    <div className="table-clumn">是</div>
                                    <div className="table-clumn">是</div>
                                </div>
                                <div className="table-view">
                                    <div className="table-clumn">位置</div>
                                    <div className="table-clumn">
                                        帮助您完成围栏预警位置查看、车辆查看及管理
                                    </div>
                                    <div className="table-clumn">是</div>
                                    <div className="table-clumn">是</div>
                                </div>
                                <div className="table-view">
                                    <div className="table-clumn">相册</div>
                                    <div className="table-clumn">
                                        帮助您完成新建维修、新建出险、新建年审、新建换车、新建交车、新建收车、新建车况物资检查、交收车编辑异常明细、新建线索跟进、新建调账、新增设备选择照片功能
                                    </div>
                                    <div className="table-clumn">是</div>
                                    <div className="table-clumn">是</div>
                                </div>
                                <div className="table-view">
                                    <div className="table-clumn">传感器</div>
                                    <div className="table-clumn">
                                        用于扫描二维码功能适配横竖屏切换
                                    </div>
                                    <div className="table-clumn">是</div>
                                    <div className="table-clumn">是</div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section>
                        <h4>
                            2. 根据相关法律法规及国家标准，在以下情形中，我们可能会依法收集并使用您的个人信息无需征得您的同意：
                        </h4>
                        <p>
                            <b>（1）与国家安全、国防安全有关的；</b>
                        </p>
                        <p>
                            <b>
                                （2）与公共安全、公共卫生、重大公共利益有关的；
                            </b>
                        </p>
                        <p>
                            <b>
                                （3）与犯罪侦查、起诉、审判和判决执行等有关的；
                            </b>
                        </p>
                        <p>
                            <b>
                                （4）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
                            </b>
                        </p>
                        <p>
                            <b>
                                （5）
                                所收集的个人信息是个人信息主体自行向社会公众公开的；
                            </b>
                        </p>
                        <p>
                            <b>
                                （6）从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；
                            </b>
                        </p>
                        <p>
                            <b>（7）根据您的要求签订合同所必需的；</b>
                        </p>
                        <p>
                            <b>
                                （8）用于维护所提供的产品与/或服务的安全稳定运行所必需的，例如发现、处置产品与/或服务的故障；
                            </b>
                        </p>
                        <p>
                            <b>（9）为合法的新闻报道所必需的；</b>
                        </p>
                        <p>
                            <b>
                                （10）学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；
                            </b>
                        </p>
                        <p>
                            <b>（11）法律法规规定的其他情形。</b>
                        </p>
                        <h4>3. 其他</h4>
                        <p>
                            请您理解，我们向您提供的服务是不断更新和发展的，
                            <b>
                                如您选择使用了前述说明中尚未涵盖的其他服务，基于该服务我们需要收集您的信息的，我们会通过页面提示、交互流程、协议约定的方式另行向您说明信息收集的范围、方式与目的，并征得您的同意
                            </b>
                            ，我们会按照本政策以及相应的用户协议约定使用、存储、对外提供及保护您的信息；如您选择不提供前述信息，您可能无法使用某项或某部分服务，但不影响您使用我们提供的其他服务。
                        </p>
                        <p>
                            在收集您的个人信息后，我们将通过技术手段对数据进行去标识化处理，去标识化处理的信息将无法识别主体。
                            <b>
                                请您了解并同意，在此情况下我们有权使用已经去标识化的信息；并在不透露您个人信息的前提下，我们有权对用户数据库进行分析并用于产品/服务的改善优化，新产品开发的利用
                            </b>
                            。
                        </p>
                    </section>
                    <section>
                        <h3>二、我们如何共享、转让、公开披露您的个人数据</h3>
                        <h4>2.1共享</h4>
                        <p>
                            原则上我们不会与本公司以外的任何公司、组织和个人分享您的个人信息，但以下情形除外：
                        </p>
                        <p>（1）获得您的明确授权或同意；</p>
                        <p>
                            （2）根据适用的法律法规、法律程序要求或强制性的政府要求或司法裁定必须提供；
                        </p>
                        <p>
                            （3）在采取有效的保护您的个人信息安全措施（包括但不限于签订相关保密协议等）的前提下，向以下主体进行共享，并在此征得您的授权同意：
                        </p>
                        <h5>2.1.1关联公司</h5>
                        <p>
                            我们可能会将您的个人信息与我们的关联公司共享，并保证其将按照本政策所示目的和要求对您的个人信息进行相应的处理。如关联公司希望将您的个人信息用于本政策所载目的以外的其他目的，我们将再次征得您的同意。
                        </p>
                        <h5>2.1.2第三方服务提供商</h5>
                        <p>
                            我们可能会在特定领域与第三方服务提供商合作，为您提供服务。我们可能会将您的个人信息与这些第三方服务提供商共享，并保证其按照我们的指示，遵循本政策所载目的和要求处理您的个人信息，并采取适当的保密和安全措施保障信息安全。
                        </p>
                        <p>
                            对我们与之共享个人信息的公司、组织和个人，我们会与其签署严格的保密协议或数据处理协议，要求其根据我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。
                        </p>
                        <p>
                            同时，为了使您能够接受信息推送、使用支付功能等必要的功能用途，我们的APP或在为您提供服务的过程中会嵌入授权合作伙伴的SDK或其他类似的应用程序。对我们与之共享个人信息的公司、组织和个人，我们将审慎评估合作方使用信息的目的，对这些合作方的安全保障能力进行综合评估，并要求其遵守合作协议。我们对合作方获取信息的SDK或其他类似的应用程序进行严格的安全监测，以保护您的信息安全。详见
                            <a
                                href="https://www.hellogil.com/h5Static/#/listOfThirdSDKGuanChe"
                                style={{
                                    color: "blue",
                                    textDecoration: "none",
                                }}
                            >
                                《第三方SDK清单》
                            </a>
                            。
                        </p>
                        <h4>2.2转让</h4>
                        <p>
                            我们不会将您的个人信息转让给任何公司、组织和个人，但以下情形除外：
                        </p>
                        <p>
                            （1）获得您的明确同意后，我们会向其他方转让您的个人信息；
                        </p>
                        <p>
                            （2）在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会在要求新的持有您个人信息的公司、组织继续受此个人信息保护政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。
                        </p>
                        <h4>2.3 公开披露</h4>
                        <p>我们仅会在以下情形下，公开披露您的个人信息：</p>
                        <p>（1）获得您明确同意后；</p>
                        <p>
                            （2）在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。
                        </p>
                        <h4>2.4 征得您授权同意的例外</h4>
                        <p>
                            以下情形中，共享、转让、公开披露个人信息无需征得您的授权和同意：
                        </p>
                        <p>（1）与您履行法律法规规定的义务相关的；</p>
                        <p>（2）与国家安全、国防安全直接相关的；</p>
                        <p>
                            （3）与公共安全、公共卫生、重大公共利益直接相关的；
                        </p>
                        <p>
                            （4）与刑事侦查、起诉、审判和判决执行等直接相关的；
                        </p>
                        <p>
                            （5）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人授权同意的；
                        </p>
                        <p>（6）个人信息主体自行向社会公众公开的个人信息；</p>
                        <p>
                            （7）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。
                        </p>
                        <p>
                            请知悉，根据适用的法律，若我们对个人信息采取技术措施和其他必要措施进行处理，使得信息接收方无法重新识别特定个人且不能复原，则此类处理后信息的共享、转让、公开披露无需另行向您通知并征得您的同意。
                        </p>
                        <h3>三、我们如何保护和保存您的个人信息</h3>
                        <h4>
                            1. 我们非常重视个人信息安全，并采取一切合理可行的措施，保护您的个人信息：
                        </h4>
                        <p>(1)数据安全技术措施</p>
                        <p>
                            我们会采用符合业界标准的安全防护措施，包括建立合理的制度规范、安全技术来防止您的个人信息遭到未经授权的访问使用、修改，避免数据的损坏或丢失。绿色慧联的网络服务采取了传输层安全协议等加密技术，通过https等方式提供浏览服务，确保用户数据在传输过程中的安全。
                        </p>
                        <p>
                            绿色慧联采取加密技术对用户个人信息进行加密保存。在个人信息使用时，例如个人信息展示、个人信息关联计算，我们会采用内容替换等数据脱敏技术增强个人信息在使用中安全性。绿色慧联采用严格的数据访问权限控制保护个人信息，避免数据被违规使用。
                        </p>
                        <p>(2)绿色慧联为保护个人信息采取的其他安全措施</p>
                        <p>
                            绿色慧联通过数据安全管理规范、数据安全开发规范来管理规范个人信息的存储和使用。绿色慧联通过信息保密协议、监控和审计机制来对数据进行全面安全控制。加强安全意识。我们还会举办信息安全培训课程，加强员工对于保护个人信息重要性的认识。
                        </p>
                        <p>
                            (3)我们仅允许有必要知晓这些信息的绿色慧联及绿色慧联关联方的员工、合作伙伴访问个人信息，并为此设置了严格的访问权限控制和监控机制。我们同时要求可能接触到您个人信息的所有人员履行相应的保密义务。如果未能履行这些义务，可能会被追究法律责任或被中止与我们的合作关系。
                        </p>
                        <p>
                            (4)我们会采取一切合理可行的措施，确保未收集无关的个人信息。我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。
                        </p>
                        <p>
                            (5)互联网并非绝对安全的环境，而且电子邮件、即时通讯、社交软件等与其他用户的交流方式无法确定是否完全加密，我们建议您使用此类工具时请使用复杂密码，并注意保护您的个人信息安全。
                        </p>
                        <p>(6)安全事件处置</p>
                        <p>
                            为应对个人信息泄露、损毁和丢失等可能出现的风险，我们制定了多项制度，明确安全事件、安全漏洞的分类分级标准及相应的处理流程。我们会按照安全事件处置规范要求，针对不同安全事件启动安全预案，进行止损、分析、定位、制定补救措施、联合相关部门进行溯源和打击。
                        </p>
                        <p>
                            在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们同时将及时将事件相关情况以邮件、电话或推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。
                        </p>
                        <h4>2. 您个人信息的保存</h4>
                        <p>(1)信息存储的地点</p>
                        <p>
                            我们依照法律法规的规定，将在境内运营过程中收集和产生的您的个人信息存储于中华人民共和国境内。目前，我们不会将上述信息传输至境外，如果我们向境外传输，我们将会遵循法律法规的规定，征求您的自主选择同意。
                        </p>
                        <p>(2)存储期限</p>
                        <p>
                            我们将在实现信息收集和处理目的的必要期限内存储您的个人信息。超出上述期限，我们将对个人信息进行删除或匿名化处理，除非法律法规有强制的留存要求。
                        </p>
                    </section>
                    <section>
                        <h3>四、您如何管理您的个人信息</h3>
                        <p>
                            绿色慧联非常重视您对个人信息的关注，并尽全力保护您对于您个人信息访问、更正、删除以及撤回同意的权利，以使您拥有充分的能力保障您的隐私和安全。您的权利包括：
                        </p>
                        <h4>1、访问您的个人信息</h4>
                        <p>
                            除法律法规规定的例外情形外，您有权随时访问您的个人信息，可以通过以下方式自行查询：
                        </p>
                        <p>1）通过“我的”，您可以访问您的姓名；</p>
                        <p>
                            对于您在使用我们的产品与/或服务过程中产生的其他个人信息需要访问，您可通过本政策载明的联系方式与我们联络。我们会根据本隐私政策所列明的方式和期限响应您的请求。
                        </p>
                        <h4>2、更正您的个人信息</h4>
                        <p>
                            除法律法规规定的例外情形外，您有权随时更正或补充您的个人信息，可以通过以下方式进行更正/补充：
                        </p>
                        <p>
                            1）通过“我的”-“账号与安全”，您可以修改您登录密码；
                        </p>
                        <p>
                            对于您在使用我们的产品与/或服务过程中产生的其他个人信息需要更正，您可通过本政策载明的联系方式与我们联络。我们会根据本隐私政策所列明的方式和期限响应您的请求。
                        </p>
                        <h4>3、获取您的个人信息副本</h4>
                        <p>
                            如您需要获取我们收集的您的个人信息副本，您可通过本政策载明的联系方式与我们联络，相关人员会对您进行必要的身份验证后，在符合相关法律规定且技术可行的前提下，将个人信息副本提交给您。如您请求将您的个人信息转移至您指定的个人信息处理者，符合国家网信部门规定条件的，我们将提供转移的途径。
                        </p>
                        <h4>4、改变您授权同意的范围或撤回您的授权</h4>
                        <p>
                            您可以通过删除信息、关闭设备功能/权限等方式改变您授权我们继续收集个人信息的范围或撤回您的授权。您也可以通过注销账户的方式，撤回我们继续收集您个人信息的全部授权。
                        </p>
                        <p>
                            请您理解，每个业务功能需要一些基本的个人信息才能得以完成，当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务，也不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响此前基于您的授权而开展的个人信息处理。
                        </p>
                        <h4>5、删除您的个人信息</h4>
                        <p>
                            在以下情形中，您可以向我们提出删除个人信息的请求：
                        </p>
                        <p>
                            （1）您的个人信息对于实现收集或处理的目的已不再必要；
                        </p>
                        <p>（2）您已经撤回我们对您个人信息处理的同意；</p>
                        <p>（3）个人信息被非法处理；</p>
                        <p>
                            （4）根据适用法律要求，我们有义务对您的个人信息进行删除。
                        </p>
                        <p>
                            您可以通过APP-客服客服或本政策载明的联系方式提出您的删除请求。请您知悉，对于您提出的敏感个人信息删除请求，我们将在10个工作日内进行删除，一般个人信息将在15个工作日内进行删除。当您从我们的服务中删除或请求删除个人信息后，因法律法规要求的最低存储期限以及安全技术限制，我们可能不会立即在备份系统中删除相应的信息，我们只会做存储不会进行其他用途直至达到法定保存期限时删除，同时，我们不会开展除存储和采取必要的安全保护措施之外的处理。
                        </p>
                        <h4>6、注销账户</h4>
                        <p>
                            您有权注销您的账号。您可以通过访问慧管车APP
                            “我的”-“账号与安全”-“注销账号”申请注销账号，或本政策载明的联系方式联系我们协助您注销，提交申请后，我们将在15个工作日内审核，确认您的账户处于安全状态等问题后，我们需要完成审核后将为您注销账户。您注销账户后，我们将停止为您提供产品/服务，并依据您的要求，除法律法规另有规定外，我们将删除您的个人信息或做匿名化处理。
                        </p>
                        <p>
                            <b>
                                出于技术原因，我们可能无法立即删除您的个人信息或做匿名化处理。我们将在系统更新时（收到您请求后的15个工作日内）删除这些个人信息或做匿名化处理。在收到您注销账号的请求后至系统更新期间，我们将不再对已收集的您的个人信息做任何处理。
                            </b>
                        </p>
                        <h4>7、响应您的请求</h4>
                        <p>
                            如果您无法通过上述方式访问、更正或删除您的个人信息，或您需要访问、更正或删除您在使用我们产品与/或服务时所产生的其他个人信息，或您认为绿色慧联存在任何违反法律法规或与您关于个人信息的收集或使用的约定，您均可以通过本政策载明的联系方式与我们联系。为了保障安全，我们可能需要您提供书面请求，或以其他方式证明您的身份，我们将在收到您反馈并验证您的身份后15个工作日内答复您的请求。对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。
                        </p>
                        <p>
                            <b>
                                在以下情形中，按照法律法规要求，我们将无法响应您的请求：
                            </b>
                        </p>
                        <p>
                            <b>（1）与国家安全、国防安全有关的；</b>
                        </p>
                        <p>
                            <b>
                                （2）与公共安全、公共卫生、重大公共利益有关的；
                            </b>
                        </p>
                        <p>
                            <b>（3）与犯罪侦查、起诉和审判等有关的；</b>
                        </p>
                        <p>
                            <b>
                                （4）有充分证据表明您存在主观恶意或滥用权利的；
                            </b>
                        </p>
                        <p>
                            <b>
                                （5）响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的。
                            </b>
                        </p>
                    </section>
                    <section>
                        <h3>五、儿童个人信息的处理</h3>
                        <p>
                            我们的产品和服务主要面向成人。尽管不同地区法律和习俗对儿童的定义不同，但我们将不满14周岁的任何人均视为儿童。我们不允许未满14周岁的儿童注册账号或使用我们的产品和服务，并且不会有意收集任何未满周14岁儿童的信息。
                        </p>
                        <p>
                            如果任何时候监护人有理由相信我们收集了未成年人的个人信息，请通过本政策载明的联系方式联系我们，我们会采取措施尽快删除相关信息。
                        </p>
                    </section>
                    <section>
                        <h3>六、通知和修订</h3>
                        <p>
                            1、为给您提供更好的服务以及随着绿色慧联业务的发展，本隐私政策也会随之更新。但未经您明确同意，我们不会削减您依据本隐私政策所应享有的权利。我们将在变更或修改生效前，通过在页面显著位置提示的方式通知您，也请您访问慧管车APP以便及时了解最新的隐私政策。
                        </p>
                        <p>
                            2、对于重大变更，我们还会提供更为显著的通知（我们会通过包括但不限于邮件、短信或在浏览页面做特别提示等方式，说明隐私政策的具体变更内容）。
                        </p>
                        <p>本政策所指的重大变更包括但不限于：</p>
                        <p>
                            （1）我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；
                        </p>
                        <p>
                            （2）我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；
                        </p>
                        <p>
                            （3）个人信息共享、转让或公开披露的主要对象发生变化；
                        </p>
                        <p>
                            （4）您参与个人信息处理方面的权利及其行使方式发生重大变化；
                        </p>
                        <p>
                            （5）我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；
                        </p>
                        <p>（6）个人信息安全影响评估报告表明存在高风险时。</p>
                    </section>
                    <section>
                        <h3>七、如何联系我们</h3>
                        <p>
                            如果您对本隐私政策有任何疑问、意见、投诉或建议，请通过以下方式与我们联系：
                        </p>
                        <p>热线： 400-826-2266</p>
                        <p>公司名称：浙江绿色慧联有限公司</p>
                        <p>
                            地址：浙江省杭州市滨江区西兴街道江陵路1760号1号楼1805室
                        </p>
                        <p>
                            我们将尽快审核所涉问题，并在验证您的用户身份后的15个工作日内予以回复。如果您请求删除您的敏感个人信息，我们将在10个工作日内回复处理意见或结果。
                        </p>
                        <p>
                            如果您对我们的回复不满意，特别是我们的个人信息处理行为损害了您的合法权益，您还可以向监管部门进行投诉或举报。
                        </p>
                    </section>
                </article>
            </div>
        );
    }
}

export default PrivacyAgreement;



// WEBPACK FOOTER //
// ./src/staticPage/privacyAgreement2/index.js